import InteractiveAnnotation from "./interactiveAnnotation";
import { setLineStyle, setBoxStyle,  } from "../canvasUtils";
import { isInBoundsLine } from "../geometry";

export default class SegmentChain extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);
    let { x, y } = position;
    this.points = [{ x, y }];
    this.min = { x: x - 5, y: y - 5 };
    this.max = { x: x + 5, y: y + 5 };

    this.active = false;
    this.drawingInitialLine = true;

    this.minSegmentLength = 5;
  }

  draw(ctx) {
    this.drawAllPoints(ctx);
  }

  drawAllPoints(ctx) {
    setLineStyle(ctx, this);

    let point = this.points[0];
    ctx.beginPath();
    ctx.moveTo(point.x, point.y);
    for (let i = 1; i < this.points.length; i++) {
      point = this.points[i];
      ctx.lineTo(point.x, point.y);
    }
    ctx.stroke();
    ctx.closePath();
  }

  drawBoundingBox(ctx) {
    setBoxStyle(ctx);
    let x = this.min.x;
    let y = this.min.y;
    let width = this.max.x - this.min.x;
    let height = this.max.y - this.min.y;
    ctx.strokeRect(x, y, width, height);
  }

  isInBounds(x, y) {
    return x >= this.min.x && x <= this.max.x
      && y >= this.min.y && y <= this.max.y;
  }

  isOnLines(x, y) 
  {
    let retVal = false;
    let head = this.points[0];
    for (let i = 1; i < this.points.length; i++) {
      let tail = this.points[i];
      if (isInBoundsLine(x, y, head.x, head.y, tail.x, tail.y))
        retVal = true;
      head = this.points[i];
    }
    return retVal
  }

  mousedown(x, y) {
    super.mousedown(x, y);
    this.active = true;
  }

  mousemove(x, y) {
    if (this.drawingInitialLine) {
      let lastPoint = this.points[this.points.length - 1];
      let nextPoint = { x, y };
      if (this.significantlyDifferent(nextPoint, lastPoint))
        this.addNextPoint(nextPoint);
    }
    else if (this.active) this.moveAllPoints(x, y);
  }

  // don't bother creating tons of points right next to eachother
  significantlyDifferent(nextPoint, lastPoint) {
    let diffX = nextPoint.x - lastPoint.x;
    let diffY = nextPoint.y - lastPoint.y;
    let squaredSum = diffX * diffX + diffY * diffY;
    return Math.sqrt(squaredSum) >= this.minSegmentLength;
  }

  addNextPoint(point) {
    this.points.push(point);
    this.updateBounds(point);
  }

  mouseup() {
    this.drawingInitialLine = false;
  }

  deactivate() {
    this.drawingInitialLine = false;
    this.active = false;
  }

  moveAllPoints(x, y) {
    const { dx, dy } = this.getAndUpdateInteraction(x, y);

    this.min.x += dx;
    this.min.y += dy;
    this.max.x += dx;
    this.max.y += dy;

    for (let i = 0; i < this.points.length; i++) {
      let point = this.points[i];
      point.x += dx;
      point.y += dy;
    }
  }

  recalculateBounds() {
    this.min.x = this.points[0].x - 5;
    this.max.x = this.points[0].x + 5;
    this.min.y = this.points[0].y - 5;
    this.max.y = this.points[0].y + 5;
    for (let i = 1; i < this.points.length; i++) this.updateBounds(this.points[i]);
  }

  updateBounds(point) {
    this.min.x = Math.min(this.min.x, point.x - 5);
    this.min.y = Math.min(this.min.y, point.y - 5);
    this.max.x = Math.max(this.max.x, point.x + 5);
    this.max.y = Math.max(this.max.y, point.y + 5);
  }
}